"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reduxActions = require("redux-actions");
var R = _interopRequireWildcard(require("ramda"));
var _actions = require("./actions");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var initialState = {
  clients: [],
  isFetchingClients: false,
  isFetchClientsFail: false,
  savingClaimIndicators: {}
};
var _default = exports.default = (0, _reduxActions.handleActions)(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _actions.clearClients, function (state) {
  return R.assoc('clients', R.clone(initialState.clients), state);
}), _actions.setClients, function (state, _ref) {
  var clients = _ref.payload;
  return R.assoc('clients', clients, state);
}), _actions.setIsFetchingClients, function (state, _ref2) {
  var isFetching = _ref2.payload;
  return R.assoc('isFetchingClients', isFetching, state);
}), _actions.setIsFetchClientsFail, function (state, _ref3) {
  var isFail = _ref3.payload;
  return R.assoc('isFetchClientsFail', isFail, state);
}), _actions.startSavingClaim, function (state, _ref4) {
  var indicatorsKey = _ref4.payload;
  return R.assocPath(['savingClaimIndicators', indicatorsKey, 'loading'], true, state);
}), _actions.finishSavingClaim, function (state, _ref5) {
  var indicatorsKey = _ref5.payload;
  return R.assocPath(['savingClaimIndicators', indicatorsKey, 'loading'], false, state);
}), _actions.successSavingClaim, function (state, _ref6) {
  var indicatorsKey = _ref6.payload;
  return R.assocPath(['savingClaimIndicators', indicatorsKey, 'success'], true, state);
}), _actions.failSavingClaim, function (state, _ref7) {
  var _ref7$payload = _ref7.payload,
    indicatorsKey = _ref7$payload.indicatorsKey,
    error = _ref7$payload.error;
  return R.assocPath(['savingClaimIndicators', indicatorsKey, 'error'], error, state);
}), _actions.clearSavingClaimIndicators, function (state, _ref8) {
  var indicatorsKey = _ref8.payload;
  return R.dissocPath(['savingClaimIndicators', indicatorsKey], state);
}), initialState);